import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { subscriptionPlans, formatCharacterName, CONTRIBUTION_CODES_REVERSE } from '../../../../utils';

const InvoiceDetails = ({invoiceData}) => {

  const isSuccessful = invoiceData.paymentStatus === 'PAID';
  const statusIcon = isSuccessful ? faCheckCircle : faTimesCircle;
  const iconColor = isSuccessful ? '#28a745' : '#dc3545'; // Green for success, red for others

  // const statusMessages = {
  //   'PENDING': 'Your subscription has been activated. Payment is pending and should complete shortly. If payment doesn’t process on the same date as this invoice, you may see a “Failed” status instead.',
  //   'COMPLETED': 'Your next billing date is ',
  //   'FAILED': 'Your payment could not be processed and your subscription was automatically canceled. Please check your PayPal account or payment method, then try subscribing again.',
  //   'CANCELLED': 'Your subscription has been canceled. If you'd like to rejoin, you can resubscribe anytime on the pricing page and select a new plan.',
  //   'EXPIRED': 'Your previous subscription has expired. If you wish to continue access, please renew your plan on the pricing page and select a new plan.',
  // };

  return (
    <div className='mt-4'>
        <h4>Invoice Details</h4>
        <div className='d-flex align-items-center mb-2'>
          <FontAwesomeIcon
            icon={statusIcon}
            style={{ color: iconColor, fontSize: '24px', marginRight: '10px', width: '20px', height: '20px' }}
          />
          <p className='m-0' style={{fontSize: "16px"}}>{invoiceData.paymentStatus.split("")[0] + invoiceData.paymentStatus.slice(1).toLowerCase()}</p>
        </div>
        {/* {invoiceData.paymentStatus.toLowerCase() === 'completed' ? (
          <p className='mb-2' style={{width: '600px', fontSize: "15px", color: "#AEAFBA"}}>
            {statusMessages[invoiceData.paymentStatus]} <b>{new Date(new Date(invoiceData.createdDate).setMonth(new Date(invoiceData.createdDate).getMonth() + 1)).toISOString().split("T")[0]}</b>. Thank you for your support!
          </p>
        ) : (
          <p className='mb-2' style={{width: '600px', fontSize: "15px", color: "#AEAFBA"}}>
            {statusMessages[invoiceData.paymentStatus] || 'There is an issue with your payment. Please contact support for assistance.'}
          </p>
        )} */}
        <div className='mb-2'>
          <p className='m-0' style={{fontSize: "16px"}}>Invoice ID</p>
          <p className='m-0'>{invoiceData.invoiceId}</p>
        </div>
        <div className='mb-2'>
          <p className='m-0' style={{fontSize: "16px"}}>Purchase Date</p>
          <p className='m-0'>{invoiceData?.createdDate.split("T")[0]} </p>
        </div>
        <div className='mb-2'>
          <p className='m-0' style={{fontSize: "16px"}}>Expiration Date</p>
          <p className='m-0'>{invoiceData?.expirationDate.split("T")[0]} </p>
        </div>
        <div className='mb-2'>
          <p className='m-0' style={{fontSize: "16px"}}>{invoiceData.purchaseType.startsWith("C") ? "Contribution Type" : "Subscription Type"}</p>
          <p className='m-0'>{invoiceData.purchaseType.startsWith("C") ? `${formatCharacterName(CONTRIBUTION_CODES_REVERSE[invoiceData.purchaseType])} Contribution` : subscriptionPlans[invoiceData.purchaseType]}</p>
        </div>
        <div className='mb-2'>
          <p className='m-0' style={{fontSize: "16px"}}>Amount</p>
          <p className='m-0'>${invoiceData?.paymentAmount || '0.00'} USD</p>
        </div>
        <div className='mb-2'>
          {/* This will require non hard coded payment method if you later support other methods */}
          <p className='m-0' style={{fontSize: "16px"}}>Payment Method</p>
          <p className='m-0'>PayPal</p>
        </div>
        <div className='mt-4'>
          <p className='m-0' style={{fontSize: "16px"}}>Questions? Visit <a href="/support" style={{color: "#FFCC19", fontWeight: "bold"}}>Help & Support</a> for more info.</p>
        </div>
    </div>
  )
}

export default InvoiceDetails